import { useMutation } from "@apollo/client";
import { ArchiveDraftOrderDocument } from "../../gql/generated/graphql";

interface Props {
  refetchQueries?: string[];
}

export const useArchiveDraftOrder = ({ refetchQueries }: Props = {}) => {
  const [archiveDraftOrder, { loading }] = useMutation(
    ArchiveDraftOrderDocument,
    { refetchQueries }
  );

  return {
    archiveDraftOrder: async (orderId: string) => {
      await archiveDraftOrder({ variables: { orderId } });
    },
    isArchiving: loading,
  };
};
